














































import { Vue, Component, Prop } from 'vue-property-decorator'
import type { FormLoja } from '@/models'
import CampoDeTelefone from '@/components/ui/CampoDeTelefone.vue'
import CampoDeCep from '@/components/ui/CampoDeCep.vue'

@Component({
	components: { CampoDeTelefone, CampoDeCep },
})
export default class BlocoProcon extends Vue {
	@Prop({ type: Object, required: true }) loja!: FormLoja

	get configuracao() {
		return this.loja.configuracaoDaLoja
	}
}
